import { useEffect } from 'react';

import { useGameSlug } from '@pkg/hooks';
import { useSearchParamsState } from '@pkg/hooks/useSearchParams';

import { useBaseCurrencyStore } from '@app/store/zustand';

const CUSTOM_CHAIN_QUERY_PARAM = 'chain';
const CUSTOM_GLOBAL_CHAIN_QUERY_PARAM = 'gChain';
enum CustomChainQueryValue {
    Polygon = 'polygon',
    Matic = 'matic',
    Aptos = 'aptos',
    Ethereum = 'eth',
}

type CurrencyQueryParams = {
    [CUSTOM_GLOBAL_CHAIN_QUERY_PARAM]?: CustomChainQueryValue;
    [CUSTOM_CHAIN_QUERY_PARAM]?: CustomChainQueryValue;
};
export const useFantasyCurrencyConfig = () => {
    const { removeParam, params } = useSearchParamsState<CurrencyQueryParams>();
    const gameSlug = useGameSlug();
    const { setGameCurrency, gameCurrencies, setCurrency, currency, defaultCurrency, setDefault } =
        useBaseCurrencyStore();

    useEffect(() => {
        const customChain = params[CUSTOM_GLOBAL_CHAIN_QUERY_PARAM];
        if (customChain) {
            switch (customChain) {
                case CustomChainQueryValue.Aptos:
                    setDefault('apt');
                    break;
                case CustomChainQueryValue.Polygon:
                case CustomChainQueryValue.Matic:
                    setDefault('matic');
                    break;
                case CustomChainQueryValue.Ethereum:
                    setDefault('eth');
                    break;
                default:
                    setDefault('usd');
            }
            removeParam(CUSTOM_GLOBAL_CHAIN_QUERY_PARAM);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    useEffect(() => {
        if (gameSlug) {
            const customChain = params[CUSTOM_CHAIN_QUERY_PARAM];
            if (customChain) {
                switch (customChain) {
                    case CustomChainQueryValue.Aptos:
                        setGameCurrency('apt', gameSlug);
                        break;
                    case CustomChainQueryValue.Polygon:
                        setGameCurrency('matic', gameSlug);
                        break;
                    case CustomChainQueryValue.Ethereum:
                        setGameCurrency('eth', gameSlug);
                        break;
                    default:
                        setGameCurrency('usd', gameSlug);
                }
                removeParam(CUSTOM_CHAIN_QUERY_PARAM);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params, gameSlug]);

    useEffect(() => {
        if (gameSlug && gameCurrencies[gameSlug]) {
            setCurrency(gameCurrencies[gameSlug], true);
        } else if (currency !== defaultCurrency) {
            setCurrency(defaultCurrency, true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameSlug, gameCurrencies, defaultCurrency]);
};
